export default __webpack_public_path__ + "images/groupem-stone-3.svg";